import { useMemo, useState } from 'react';

import { ChakraFlex } from '@equip.health/ui';
import { useHistory } from 'react-router-dom';

import { ChatChannelSelectType } from '~/lib/util/chat/chatChannel.util';
import { dropdownMenuOptionsMapper } from '~/lib/util/inquiry.util';
import { Path } from '~/routes/constants';

import PatientMyChannels from './PatientMyChannels';
import PatientOtherChannels from './PatientOtherChannels';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorChannel from './ErrorChannel';

interface PatientMessagesTabProps {
  patient: Patient;
  patientFirstName: string;
  patientId: string;
}

const PatientMessagesTab = ({
  patient,
  patientFirstName,
  patientId,
}: PatientMessagesTabProps) => {
  const [selectedChannelType, setSelectedChannelType] = useState<string>(
    ChatChannelSelectType.MYCHANNELS,
  );

  const universalStatusCode = patient.universalStatusCode ?? '';

  const history = useHistory();

  const handleOnChangeChannelType = (input: string) => {
    if (selectedChannelType !== input) {
      setSelectedChannelType(input);
    }
    history.push(`${Path.MAUD_PATIENTS}/${patientId}/messages`);
  };

  const channelTypeOptions = useMemo<UniversalSelectOption[]>(() => {
    return dropdownMenuOptionsMapper([
      ChatChannelSelectType.MYCHANNELS,
      ChatChannelSelectType.OTHERCHANNELS,
    ]);
  }, []);

  const errorFallback = (props) => <ErrorChannel {...props} />;

  return (
    <ChakraFlex direction="column" gap="10px" height="100%">
      <ErrorBoundary
        fallbackRender={errorFallback}
        onReset={() => {
          history.push(`${Path.MAUD_PATIENTS}/${patientId}/messages`);
        }}
      >
        {ChatChannelSelectType.MYCHANNELS === selectedChannelType ? (
          <PatientMyChannels
            channelTypeOptions={channelTypeOptions}
            key={patientId}
            onChannelTypeSelect={handleOnChangeChannelType}
            patientFirstName={patientFirstName}
            patientId={patientId}
            selectedChannelType={selectedChannelType}
            universalStatusCode={universalStatusCode}
          />
        ) : (
          <PatientOtherChannels
            channelTypeOptions={channelTypeOptions}
            key={patientId}
            onChannelTypeSelect={handleOnChangeChannelType}
            patientFirstName={patientFirstName}
            patientId={patientId}
            selectedChannelType={selectedChannelType}
            universalStatusCode={universalStatusCode}
          />
        )}
      </ErrorBoundary>
    </ChakraFlex>
  );
};

export default PatientMessagesTab;
